import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LeapEntryPointComponent } from './entry-point/entry-point.component';

const routes: Routes = [
	{
		path: 'leap',
		component: LeapEntryPointComponent,
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class LeapRoutingModule {}
